import React from 'react'
import { Button } from 'react-bootstrap'
import { useForm } from 'react-hook-form';
import { Tabs, Tab } from 'react-bootstrap';
import { useState } from 'react';
import NumberFormat from 'react-number-format';
import Pagination from 'react-bootstrap-4-pagination';
import BanDoNongHoaApi from '../../api/BanDoNongHoaApi';

export const TimKiemNongHoa = (props) => {
    const { register, handleSubmit } = useForm();
    const [listKetQuas, setKetQua] = useState([]);
    const [tongRow, setTongRow] = useState(-1);
    const [tongDienTich, setTongDienTich] = useState(0);
    let query = '';
    let pageIndex = 1;
    const timKiem = (data) => {
        query = getSql(data);
        props.timKiem(query);
        loadDuLieu();
    }
    const getSql = (data) => {
        let sql = '';
        if (data.TenXa !== "") {
            sql = `"tenXa" ilike '${data.TenXa}'`
        }
        if (data.maNongHoa !== "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"maNongHoa"=${data.maNongHoa}`
        }
        if (data.DienTichMin !== "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"DienTich" ${data.DienTichDieuKienMin} ${data.DienTichMin} `
        }
        if (data.DienTichMax !== "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"DienTich" ${data.DienTichDieuKienMax} ${data.DienTichMax}`
        }
        if (data.phKClMin !== "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"phKCl" ${data.phKClDieuKienMin} ${data.phKClMin}`
        }
        if (data.phKClMax !== "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"phKCl" ${data.phKClDieuKienMax} ${data.phKClMax}`
        }
        if (data.tsDamMin !== "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"tsDam" ${data.tsDamDieuKienMin} ${data.tsDamMin}`
        }
        if (data.tsDamMax !== "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"tsDam" ${data.tsDamDieuKienMax} ${data.tsDamMax}`
        }
        if (data.tsLanMin !== "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"tsLan" ${data.tsLanDieuKienMin} ${data.tsLanMin}`
        }
        if (data.tsLanMax !== "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"tsLan" ${data.tsLanDieuKienMax} ${data.tsLanMax}`
        }
        if (data.tsKaliMin !== "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"tsKali" ${data.tsKaliDieuKienMin} ${data.tsKaliMin} `
        }
        if (data.tsKaliMax !== "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"tsKali" ${data.tsKaliDieuKienMax} ${data.tsKaliMax}`
        }
        if (data.dtLanMin !== "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"dtLan" ${data.dtLanDieuKienMin} ${data.dtLanMin}  `
        }
        if (data.dtLanMax !== "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"dtLan" ${data.dtLanDieuKienMax} ${data.dtLanMax}`
        }
        if (data.dtKaLiMin !== "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"dtKali" ${data.dtKaLiDieuKienMin} ${data.dtKaLiMin}  `
        }
        if (data.dtKaLiMax !== "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"dtKali" ${data.dtKaLiDieuKienMax} ${data.dtKaLiMax}`
        }
        if (data.cECMin !== "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"CEC" ${data.cECDieuKienMin} ${data.cECMin}  `
        }
        if (data.cECMax !== "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"CEC" ${data.cECDieuKienMax} ${data.cECMax}`
        }
        if (data.oCMin !== "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"OC" ${data.oCDieuKienMin} ${data.oCMin}`
        }
        if (data.oCMax !== "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"OC" ${data.oCDieuKienMax} ${data.oCMax}`
        }
        if (sql !== '') {
            sql = props.queryHuyen + ' AND ' + sql
        }
        else {
            sql = props.queryHuyen;
        }
        return sql;
    }

    const exportExcel = (data) => {
        const sql = getSql(data);
        props.exportExcel(sql);
    }

    const clickTab = (k) => {
    }


    const loadDuLieu = () => {
        props.timKiemLoading(true);
        const params = {
            pageIndex: pageIndex,
            sql: query
        }
        BanDoNongHoaApi.getPaging(params).then((res) => {
            setKetQua(res.Items);
            paginationConfig.totalPages = (Math.ceil(res.TotalRow / 20) === 0?1:Math.ceil(res.TotalRow / 20));
            paginationConfig.currentPage = pageIndex;
            setTongRow(res.TotalRow);
            setTongDienTich(res.TongDienTich);
            paginationConfig.onClick = function (page) {
                pageIndex = page;
                loadDuLieu();
            }
            setPaging(paginationConfig);
            props.timKiemLoading(false);
        }, (err) => {
            props.timKiemLoading(false);
        })
    }

    const clickRow = (id) => {
        props.timKiemGetChiTiet({
            id: id,
            tableName: 'HaNoi_vgNongHoa'
        })
    }

    const [paginationConfig, setPaging] = useState({
        totalPages: 1,
        currentPage: 1,
        showMax: 5,
        size: "sm",
        threeDots: true,
        prevNext: true,
        onClick: function (page) {
            pageIndex = page;
            loadDuLieu();
        }
    });

    return (
        <Tabs defaultActiveKey="timkiem" onSelect={(k) => clickTab(k)}>
            <Tab eventKey="timkiem" title="Tìm kiếm">
                <form className="frmtimkiem">
                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label text-right">Tên xã</label>
                        <div className="col-sm-8">
                            <input name="TenXa" type="text" className="form-control" placeholder="Tên xã" ref={register} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label text-right">Mã nông hóa</label>
                        <div className="col-sm-8">
                            <input name="maNongHoa" type="text" className="form-control" placeholder="Nhập mã nông hóa" ref={register} />
                        </div>
                    </div>
                    <div className="form-group row tkdientich">
                        <div className="col-sm-3">
                            <input name="DienTichMin" type="number" className="form-control" placeholder="ha" ref={register} />
                        </div>
                        <div className="col-sm-2 select-dt">
                            <select class="form-control" name="DienTichDieuKienMin" ref={register}>
                                <option value=">">&#60;</option>
                                <option value=">=">&#60;&#61;</option>
                            </select>
                        </div>
                        <label className="col-sm-2 col-form-label text-center">Diện tích</label>
                        <div className="col-sm-2 select-dt">
                            <select class="form-control" name="DienTichDieuKienMax" ref={register}>
                                <option value="<">&#60;</option>
                                <option value="<=">&#60;&#61;</option>
                            </select>
                        </div>
                        <div className="col-sm-3">
                            <input name="DienTichMax" type="number" className="form-control" placeholder="ha" ref={register} />
                        </div>
                    </div>
                    <div className="form-group row tkdientich">
                        <div className="col-sm-3">
                            <input name="phKClMin" type="number" className="form-control" placeholder="" ref={register} />
                        </div>
                        <div className="col-sm-2 select-dt">
                            <select class="form-control" name="phKClDieuKienMin" ref={register}>
                                <option value=">">&#60;</option>
                                <option value=">=">&#60;&#61;</option>
                            </select>
                        </div>
                        <label className="col-sm-2 col-form-label text-center">phKCl</label>
                        <div className="col-sm-2 select-dt">
                            <select class="form-control" name="phKClDieuKienMax" ref={register}>
                                <option value="<">&#60;</option>
                                <option value="<=">&#60;&#61;</option>
                            </select>
                        </div>
                        <div className="col-sm-3">
                            <input name="phKClMax" type="number" className="form-control" placeholder="" ref={register} />
                        </div>
                    </div>
                    <div className="form-group row tkdientich">
                        <div className="col-sm-3">
                            <input name="tsDamMin" type="number" className="form-control" placeholder="" ref={register} />
                        </div>
                        <div className="col-sm-2 select-dt">
                            <select class="form-control" name="tsDamDieuKienMin" ref={register}>
                                <option value=">">&#60;</option>
                                <option value=">=">&#60;&#61;</option>
                            </select>
                        </div>
                        <label className="col-sm-2 col-form-label text-center">tsDam</label>
                        <div className="col-sm-2 select-dt">
                            <select class="form-control" name="tsDamDieuKienMax" ref={register}>
                                <option value="<">&#60;</option>
                                <option value="<=">&#60;&#61;</option>
                            </select>
                        </div>
                        <div className="col-sm-3">
                            <input name="tsDamMax" type="number" className="form-control" placeholder="" ref={register} />
                        </div>
                    </div>
                    <div className="form-group row tkdientich">
                        <div className="col-sm-3">
                            <input name="tsLanMin" type="number" className="form-control" placeholder="" ref={register} />
                        </div>
                        <div className="col-sm-2 select-dt">
                            <select class="form-control" name="tsLanDieuKienMin" ref={register}>
                                <option value=">">&#60;</option>
                                <option value=">=">&#60;&#61;</option>
                            </select>
                        </div>
                        <label className="col-sm-2 col-form-label text-center">tsLan</label>
                        <div className="col-sm-2 select-dt">
                            <select class="form-control" name="tsLanDieuKienMax" ref={register}>
                                <option value="<">&#60;</option>
                                <option value="<=">&#60;&#61;</option>
                            </select>
                        </div>
                        <div className="col-sm-3">
                            <input name="tsLanMax" type="number" className="form-control" placeholder="" ref={register} />
                        </div>
                    </div>
                    <div className="form-group row tkdientich">
                        <div className="col-sm-3">
                            <input name="tsKaliMin" type="number" className="form-control" placeholder="" ref={register} />
                        </div>
                        <div className="col-sm-2 select-dt">
                            <select class="form-control" name="tsKaliDieuKienMin" ref={register}>
                                <option value=">">&#60;</option>
                                <option value=">=">&#60;&#61;</option>
                            </select>
                        </div>
                        <label className="col-sm-2 col-form-label text-center">tsKali</label>
                        <div className="col-sm-2 select-dt">
                            <select class="form-control" name="tsKaliDieuKienMax" ref={register}>
                                <option value="<">&#60;</option>
                                <option value="<=">&#60;&#61;</option>
                            </select>
                        </div>
                        <div className="col-sm-3">
                            <input name="tsKaliMax" type="number" className="form-control" placeholder="" ref={register} />
                        </div>
                    </div>
                    <div className="form-group row tkdientich">
                        <div className="col-sm-3">
                            <input name="dtLanMin" type="number" className="form-control" placeholder="" ref={register} />
                        </div>
                        <div className="col-sm-2 select-dt">
                            <select class="form-control" name="dtLanDieuKienMin" ref={register}>
                                <option value=">">&#60;</option>
                                <option value=">=">&#60;&#61;</option>
                            </select>
                        </div>
                        <label className="col-sm-2 col-form-label text-center">dtLan</label>
                        <div className="col-sm-2 select-dt">
                            <select class="form-control" name="dtLanDieuKienMax" ref={register}>
                                <option value="<">&#60;</option>
                                <option value="<=">&#60;&#61;</option>
                            </select>
                        </div>
                        <div className="col-sm-3">
                            <input name="dtLanMax" type="number" className="form-control" placeholder="" ref={register} />
                        </div>
                    </div>
                    <div className="form-group row tkdientich">
                        <div className="col-sm-3">
                            <input name="dtKaLiMin" type="number" className="form-control" placeholder="" ref={register} />
                        </div>
                        <div className="col-sm-2 select-dt">
                            <select class="form-control" name="dtKaLiDieuKienMin" ref={register}>
                                <option value=">">&#60;</option>
                                <option value=">=">&#60;&#61;</option>
                            </select>
                        </div>
                        <label className="col-sm-2 col-form-label text-center">dtKaLi</label>
                        <div className="col-sm-2 select-dt">
                            <select class="form-control" name="dtKaLiDieuKienMax" ref={register}>
                                <option value="<">&#60;</option>
                                <option value="<=">&#60;&#61;</option>
                            </select>
                        </div>
                        <div className="col-sm-3">
                            <input name="dtKaLiMax" type="number" className="form-control" placeholder="" ref={register} />
                        </div>
                    </div>
                    <div className="form-group row tkdientich">
                        <div className="col-sm-3">
                            <input name="cECMin" type="number" className="form-control" placeholder="" ref={register} />
                        </div>
                        <div className="col-sm-2 select-dt">
                            <select class="form-control" name="cECDieuKienMin" ref={register}>
                                <option value=">">&#60;</option>
                                <option value=">=">&#60;&#61;</option>
                            </select>
                        </div>
                        <label className="col-sm-2 col-form-label text-center">CEC</label>
                        <div className="col-sm-2 select-dt">
                            <select class="form-control" name="cECDieuKienMax" ref={register}>
                                <option value="<">&#60;</option>
                                <option value="<=">&#60;&#61;</option>
                            </select>
                        </div>
                        <div className="col-sm-3">
                            <input name="cECMax" type="number" className="form-control" placeholder="" ref={register} />
                        </div>
                    </div>
                    <div className="form-group row tkdientich">
                        <div className="col-sm-3">
                            <input name="oCMin" type="number" className="form-control" placeholder="" ref={register} />
                        </div>
                        <div className="col-sm-2 select-dt">
                            <select class="form-control" name="oCDieuKienMin" ref={register}>
                                <option value=">">&#60;</option>
                                <option value=">=">&#60;&#61;</option>
                            </select>
                        </div>
                        <label className="col-sm-2 col-form-label text-center">OC</label>
                        <div className="col-sm-2 select-dt">
                            <select class="form-control" name="oCDieuKienMax" ref={register}>
                                <option value="<">&#60;</option>
                                <option value="<=">&#60;&#61;</option>
                            </select>
                        </div>
                        <div className="col-sm-3">
                            <input name="oCMax" type="number" className="form-control" placeholder="" ref={register} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="col-sm-12 text-right">
                            <Button variant="info mr-1" size="sm" onClick={handleSubmit(exportExcel)}><i className="fas fa-file-excel"></i> Excel</Button>
                            <Button variant="success" size="sm" onClick={handleSubmit(timKiem)}><i className="fas fa-search"></i> Tìm kiếm</Button>
                        </div>
                    </div>
                    {
                        tongRow > -1 ?
                            <div className="form-group row">
                                <label className="col-sm-4 col-form-label text-right">Kết quả:</label>
                                <div className="col-sm-8">
                                    <h5 className="ket-qua-tim-kiem"><NumberFormat value={tongRow} displayType={'text'} thousandSeparator={true} decimalScale={2}></NumberFormat> khoảnh đất</h5>
                                </div>
                                <label className="col-sm-4 col-form-label text-right">Tổng diện tích:</label>
                                <div className="col-sm-8">
                                    <h5 className="ket-qua-tim-kiem"><NumberFormat value={tongDienTich} displayType={'text'} thousandSeparator={true} decimalScale={2}></NumberFormat> ha</h5>
                                </div>
                            </div> : ''
                    }
                </form>
            </Tab>
            <Tab eventKey="ketqua" title="Kết quả">
                {
                    <>
                        <table className="table table-bordered tb-chu-giai" width="100%">
                            <thead>
                                <tr>
                                    <th>Huyện</th>
                                    <th>Xã</th>
                                    <th>Mã nông hóa</th>
                                    <th>Diện tích</th>

                                </tr>
                            </thead>
                            <tbody>
                                {
                                    listKetQuas.length === 0 ? <tr>
                                        <td colSpan="100%">Không có bản ghi được tìm thấy</td>
                                    </tr> :
                                        listKetQuas.map((item, key) => {
                                            return (
                                                <tr key={key} onClick={() => clickRow(item.id)}>
                                                    <td>{item.tenHuyen}</td>
                                                    <td>{item.tenXa}</td>
                                                    <td>{item.maNongHoa}</td>
                                                    <td>
                                                        <NumberFormat value={item.DienTich} displayType={'text'} thousandSeparator={true} decimalScale={2}></NumberFormat>
                                                    </td>

                                                </tr>
                                            )
                                        })
                                }
                            </tbody>
                        </table>
                        <Pagination {...paginationConfig} />
                    </>
                }
            </Tab>
        </Tabs>

    )
}
